import React, { useEffect } from "react";

// import { clearEntrySteps, clearEntryStepActive } from '../actions/entryActions';

// COMPONENTS
// import MainHeaderNav from '../components/navigations/MainHeaderNav';
// import MainBoxNav from '../components/navigations/MainBoxNav';
// import FooterMain from '../components/footers/FooterMain';
// import ContentContainer from "../components/layout/ContentContainer";

const Testing = () => {
  useEffect(() => {
    //setCounter(true);
  }, []);

  return (
    <div className="App" style={{width: '500px', padding: '3rem'}}>



      {/* <TogglePrompt

        msg={['msg a', 'msg b']}
        btnText={['btn 1', 'btn 2']}
        view={false}
        callback={false}
      /> */}

      {/* <button data-focusid="42" onClick={showModal}>
        Show Modal
      </button> */}

      {/* <ModalPortal>
        <Modal
          oldTemplateDesign
          visible={isVisible}
          focusedElBeforeModalID="42"
          buttons={[
            { id: 1, value: "Yes", onClick: loading },
            { id: 2, value: "No", onClick: cancel },
          ]}
          closeModal={cancel}
          // loader={loader}
          title="Nullam volutpat fringilla"
          text="Aenean at felis ut arcu tempus pellentesque. Vivamus erat lacus, rutrum vel sodales ac, tincidunt vitae quam."
        />
      </ModalPortal> */}
    </div>
  );
};

export default Testing;
